import { Injectable } from '@angular/core';
import { map, of, firstValueFrom } from 'rxjs';
import { TiposEtapasModalidadeSerieDto } from '../../dtos';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListTiposEtapasModalidadeSerie {
  content: TiposEtapasModalidadeSerieDto[];
}

@Injectable({
  providedIn: 'root'
})
export class TiposEtapasModalidadeSerieService {

  constructor(private caqRequestService: CaqRequestService) { }

  mock: TiposEtapasModalidadeSerieDto[] = [
    {co_tr_tp_etapas_modalidade_por_serie: 11, descricao: 'Creche - menor de 1 ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 12, descricao: 'Creche - 1 ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 13, descricao: 'Creche - 2 anos'},
    {co_tr_tp_etapas_modalidade_por_serie: 14, descricao: 'Creche - 3 anos'},
    {co_tr_tp_etapas_modalidade_por_serie: 21, descricao: 'Pré-escola - 4 anos'},
    {co_tr_tp_etapas_modalidade_por_serie: 22, descricao: 'Pré-escola - 5 anos'},
    {co_tr_tp_etapas_modalidade_por_serie: 31, descricao: 'Ens. Fundamental - 1º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 32, descricao: 'Ens. Fundamental - 2º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 33, descricao: 'Ens. Fundamental - 3º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 34, descricao: 'Ens. Fundamental - 4º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 35, descricao: 'Ens. Fundamental - 5º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 41, descricao: 'Ens. Fundamental - 6º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 42, descricao: 'Ens. Fundamental - 7º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 43, descricao: 'Ens. Fundamental - 8º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 44, descricao: 'Ens. Fundamental - 9º ano'},
    {co_tr_tp_etapas_modalidade_por_serie: 51, descricao: 'Ens. Médio - 1ª serie'},
    {co_tr_tp_etapas_modalidade_por_serie: 52, descricao: 'Ens. Médio - 2ª serie'},
    {co_tr_tp_etapas_modalidade_por_serie: 53, descricao: 'Ens. Médio - 3ª serie'},
    {co_tr_tp_etapas_modalidade_por_serie: 54, descricao: 'Ens. Médio - 4ª serie'},
    {co_tr_tp_etapas_modalidade_por_serie: 61, descricao: 'EJA - anos inicias do Ens. Fundamental'},
    {co_tr_tp_etapas_modalidade_por_serie: 62, descricao: 'EJA - anos finais do Ens. Fundamental'},
    {co_tr_tp_etapas_modalidade_por_serie: 63, descricao: 'EJA - Ens. Médio'},
    {co_tr_tp_etapas_modalidade_por_serie: 71, descricao: 'Educação Profissional'},
    {co_tr_tp_etapas_modalidade_por_serie: 99, descricao: 'Não classificado'}
  ];

  buscarListaDeTiposEtapasModalidadeSerie(): Promise<TiposEtapasModalidadeSerieDto[]> {
    return firstValueFrom(of(this.mock));
  }
}
